import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=b13e295a&scoped=true&"
import script from "./Loading.vue?vue&type=script&lang=js&"
export * from "./Loading.vue?vue&type=script&lang=js&"
import style0 from "./Loading.vue?vue&type=style&index=0&id=b13e295a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13e295a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b13e295a')) {
      api.createRecord('b13e295a', component.options)
    } else {
      api.reload('b13e295a', component.options)
    }
    module.hot.accept("./Loading.vue?vue&type=template&id=b13e295a&scoped=true&", function () {
      api.rerender('b13e295a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Loading.vue"
export default component.exports